export default __webpack_public_path__ + "static/media/solutions-architect.55532442.png";